import styled from 'styled-components';

export const ErrorMessage = styled.div`
  margin: 10px 0;
  background-color: #ffcaca;
  color: #000;
  border: 2px solid #ffcab9;
  padding: 10px;
`;